import "./BrandMark.css";
import { InfinityHearts } from "./InfinityHearts";
import { useT } from "../i18n";

/** Full lockup (wordmark). The standalone sign is UnlimitedSign.png. */
export const UN8_LOCKUP_SRC = "/brand/un8-lockup.png";

export function BrandMark({
  hero = false,
  compact = false,
}: {
  hero?: boolean;
  /** Lockup only — caller supplies its own tag (MatchApp i18n). */
  compact?: boolean;
}) {
  const t = useT();
  return (
    <div
      className={hero ? "brand brand--hero" : compact ? "brand brand--compact" : "brand"}
      aria-label="UN8"
    >
      {compact ? (
        <img
          className="brand__lockup brand__lockup--raster"
          src={UN8_LOCKUP_SRC}
          alt=""
          decoding="async"
        />
      ) : (
        <InfinityHearts className="brand__lockup" />
      )}
      {compact ? null : <span className="brand__tag">{t("common.brandTag")}</span>}
    </div>
  );
}
